<template>
    <div class="container">
        <div class="row additional-images-row">
            <div class="d-block w-100 search-results-container">
                <span class="heading">Related Images</span>
                <loading :loading="loading" :full-page="false"/>
                <div class="similar-images-wrap animate-opacity" :style="{'opacity': `${loading?0:1}`}">
                    <stock-image-thumbnail v-for="similarImage in fetchedImages" :key="similarImage.id" :image="similarImage" :show-in-album-link="false" :show-similar-link="false" @image-loaded="imageLoaded"/>
                </div>
                <div class="text-center animate-opacity" :style="{'opacity': `${loading?0:1}`}">
                    <nuxt-link :to="`/search?term=similar to:${image.code}`" class="btn btn-default btn-hollow large" target="_blank">
                        See all related stock
                    </nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loading from '../global/Loading.vue'
import StockImageThumbnail from '../StockImageThumbnail.vue'

export default {
    name: 'SimilarImages',
    components: {
        StockImageThumbnail,
        Loading
    },
    props: {
        image: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            loading: true,
            fetchedImages: null,
            totalLoaded: 0
        }
    },
    mounted () {
        // this.fetchImages()
    },
    methods: {
        async fetchImages () {
            await axios.get(`/stock-images/similar/${this.image.code}`)
                .then(rsp => rsp.data)
                .then((response) => {
                    if (response.data.length > 0) {
                        this.fetchedImages = response.data
                    }
                })
                .finally(() => {

                })
        },
        imageLoaded () {
            this.totalLoaded = this.totalLoaded + 1

            if (this.totalLoaded === this.fetchedImages.length) {
                this.loading = false
            }
        }
    }
}
</script>
